import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

export default function AvatarCard({ program, index = 0 }) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: index * 0.08, ease: "easeOut" }}
        >
            <Link
                to={program.path}
                data-testid={`avatar-card-${program.slug}`}
                className="group relative block overflow-hidden border border-zinc-900 hover:border-brand-red transition-colors duration-300"
            >
                <div className="relative aspect-[4/5] overflow-hidden bg-zinc-950">
                    <img
                        src={program.image}
                        alt={program.title}
                        loading="lazy"
                        className="absolute inset-0 w-full h-full object-cover grayscale-[35%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700 ease-out"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />
                    <div className="absolute top-4 left-4 right-4 flex items-center justify-between">
                        <span className="inline-block text-[10px] tracking-[0.25em] uppercase bg-black/70 backdrop-blur-sm border border-zinc-800 px-3 py-1.5">
                            {program.eyebrow}
                        </span>
                        <span className="inline-flex items-center justify-center w-9 h-9 bg-brand-red text-white opacity-0 group-hover:opacity-100 translate-y-1 group-hover:translate-y-0 transition-all duration-300">
                            <ArrowUpRight className="w-4 h-4" />
                        </span>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 p-6 md:p-7">
                        <div className="font-display text-4xl md:text-5xl tracking-wider text-white leading-none">
                            {program.title}
                        </div>
                        <p className="mt-3 text-sm text-zinc-300 max-w-sm">
                            {program.tagline}
                        </p>
                    </div>
                </div>
                <div className="absolute left-0 bottom-0 h-1 w-0 group-hover:w-full bg-brand-red transition-all duration-500 ease-out" />
            </Link>
        </motion.div>
    );
}
